import { faker } from "@faker-js/faker";

import { Team } from "@protos/permissions/v2/permissions";

export const generateTeamData = (parentId: number | null) => {
  const rootTeams: Team[] = [];
  const deploymentId = faker.number.int();
  const length = faker.number.int({ min: 2, max: 5 });

  const makeChildIds = () => {
    return Array.from({
      length: faker.number.int({ min: 0, max: 10 }),
    }).map(() => faker.number.int());
  };

  for (let i = 0; i < length; i++) {
    const childIds = makeChildIds();
    rootTeams.push(
      Team.create({
        id: faker.number.int(),
        name: faker.lorem.word(),
        deploymentId: deploymentId,
        slug: faker.lorem.slug(),
        childTeamIds: childIds,
        childTeamCount: childIds.length,
        repositoryCount: faker.number.int({ min: 0, max: 10 }),
        userCount: faker.number.int({ min: 0, max: 10 }),
        parentTeamId: parentId ?? undefined,
      })
    );
  }

  const teamChildIds = makeChildIds();

  const team: Team = Team.create({
    id: faker.number.int(),
    name: faker.lorem.word(),
    deploymentId: deploymentId,
    slug: faker.lorem.slug(),
    childTeamIds: teamChildIds,
    childTeamCount: teamChildIds.length,
    repositoryCount: faker.number.int({ min: 0, max: 10 }),
    userCount: faker.number.int({ min: 0, max: 10 }),
    parentTeamId: parentId ?? undefined,
  });

  return {
    teams: rootTeams,
    team,
  };
};
